import React from 'react';

const Step3Success = ({ selectedCategory }) => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-red-smdd rounded-full flex items-center justify-center mr-4">
          <span className="text-white text-sm font-bold">3</span>
        </div>
        <div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black">
            Submission Complete
          </h2>
        </div>
      </div>

      <div className="text-center py-8 ml-12 mr-12">
        <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-white"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <h3 className="text-xl font-baijamjuree font-bold text-black mb-3">
          Submission Successful!
        </h3>
        <p className="text-gray-700 mb-4 font-baijamjuree">
          Your{' '}
          <span className="font-semibold text-red-smdd">
            {selectedCategory}
          </span>{' '}
          submission has been received. Thank you for participating in SMDD
          {` `}
          {currentYear}!
        </p>
        <p className="text-sm text-gray-500 font-baijamjuree">
          A confirmation email has been sent to your registered email address.
        </p>
      </div>
    </div>
  );
};

export default Step3Success;
